<script>
    import { Form } from 'element-ui';
    import { mapActions, mapState, mapMutations } from 'vuex';
    import Loader from '~/components/loader/components/loader';
    import PasswordStrength from '~/components/password_strength/components/password_strength';
    import TogglePasswordInput from '~/components/toggle_password_input/components/toggle_password_input';
    import Vue from 'vue';

    Vue.use(Form);

    export default {
        name: 'update-password-form',

        components: {
            Loader,
            PasswordStrength,
            TogglePasswordInput
        },

        mounted() {
            this.getPasswordRules();
        },

        data() {
            return {
                rules: {
                    confirmPassword: [
                        {
                            validator: this.validatePasswordMatch,
                            trigger: 'change'
                        }
                    ],
                    newPassword: [
                        {
                            validator: this.validateCurrentPassword,
                            trigger: 'blur'
                        }
                    ],
                },
            }
        },

        props: {
            currentPassword: {
                type: String
            },
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'passwordForm',
                'passwordRules'
            ]),
        },

        methods: {
            ...mapActions('passwordSettings', [
                'getPasswordRules',
            ]),

            ...mapMutations('passwordSettings', [
                'updatePasswordIsValid',
            ]),

            validateCurrentPassword(rule, value, callback) {
                if (this.passwordForm.password.length === 0) {
                    callback(new Error('Please enter your current password'));
                }
            },

            validateNewPassword() {
                if (this.passwordForm.password.length > 0 && this.passwordForm.newPassword.length !== 0) {
                    this.$refs['passwordForm'].validateField('newPassword');
                }
            },

            validatePasswordMatch(rule, value, callback) {
                if (value !== this.passwordForm.newPassword) {
                    callback(new Error('Passwords do not match'));
                }
            },
        },
    }
</script>

<template>
    <div>
        <loader :is-loading="loading.passwordRules"></loader>

        <div class="col-xs-12 col-sm-6 p-0">
            <el-form
                :model="passwordForm"
                ref="passwordForm"
                :rules="rules"
                @submit.native.prevent>
                <div class="row">
                    <div class="col-xs-12">
                        <toggle-password-input
                            prop-name="currentPassword"
                            label-name="Current Password"
                            v-model="passwordForm.password"
                            @input="validateNewPassword">
                        </toggle-password-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <toggle-password-input
                            prop-name="newPassword"
                            label-name="New Password"
                            v-model="passwordForm.newPassword">
                        </toggle-password-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <toggle-password-input
                            prop-name="confirmPassword"
                            label-name="Confirm Password"
                            v-model="passwordForm.confirmPassword">
                        </toggle-password-input>
                    </div>
                </div>
            </el-form>
        </div>

        <div class="col-xs-12 col-sm-6 p-0">
            <password-strength
                :rules="passwordRules"
                :value="passwordForm.newPassword"
                @password-changed="updatePasswordIsValid">
            </password-strength>
        </div>
    </div>
</template>
